import { render, staticRenderFns } from "./connectResource.vue?vue&type=template&id=615fc874&scoped=true"
import script from "./connectResource.vue?vue&type=script&lang=js"
export * from "./connectResource.vue?vue&type=script&lang=js"
import style0 from "./connectResource.vue?vue&type=style&index=0&id=615fc874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615fc874",
  null
  
)

export default component.exports